module.exports = __webpack_public_path__ + "img/right_white.f5f440dd.svg";